<template>
  <form @submit.prevent="submit">
    <base-modal small target="investorRemoveSharesModal" title="Remove Shares">
      <template v-if="ready && !isDissolvePending">
        <base-field label="Investor">
          <base-select
            v-model="payload.user"
            :model="investors"
            model-text="user.email"
            model-value="user._id"
            placeholder="investor"
            required
            @input="getInvestorShares"
          />
        </base-field>
        <base-field v-if="rounds.length" label="Funding">
          <base-select
            v-model="payload.funding"
            :model="rounds"
            model-text="funding.name"
            model-value="funding._id"
            placeholder="funding"
            required
            @input="getSharesAvailable"
          />
        </base-field>
        <template v-if="payload.funding">
          <base-field addon-left-icon="pound-sign" label="Amount" mandatory>
            <base-input v-model="payload.amount" numeric placeholder="amount" required />
          </base-field>
          <div class="bg-light text-center">
            <strong>{{ $formatting.toCurrency(max) }}</strong> available to be removed.
          </div>
          <base-checkbox v-model="payload.reduceFunded" class="my-2">
            Reduce total funded from funding round?
          </base-checkbox>
        </template>
        <base-button
          v-if="payload.user && payload.funding && payload.amount"
          block
          secondary
          type="submit"
        >
          Remove
        </base-button>
      </template>
      <template v-else>
        <base-loader />
      </template>
    </base-modal>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import EventBus from '../libs/EventBus'

export default {
  name: 'InvestorRemoveShares',

  data: () => ({
    investors: [],
    max: 0,
    payload: {
      amount: '',
      funding: '',
      investment: '',
      reduceFunded: false,
      user: ''
    },
    ready: false,
    rounds: [],
    shares: []
  }),

  computed: {
    ...mapState({
      investment: store => store.core.investments.entity,
      isDissolvePending: store => store.core.shares.isDissolvePending
    })
  },

  async created () {
    this.investors = await this.getInvestors({
      populate: ['user'],
      query: {
        investment: this.investment._id
      }
    })
    this.payload.investment = this.investment._id

    this.ready = true
  },

  methods: {
    async getInvestorShares () {
      this.max = 0
      this.payload.amount = ''
      this.payload.funding = ''
      this.rounds = []

      const shares = await this.getTrail({
        investment: this.investment._id,
        user: this.payload.user
      })

      this.shares = this.$_.sortBy(shares, ['funding.name'])
      this.shares.forEach((share) => {
        let index
        const added = this.rounds.find((r, i) => {
          index = i
          return r.funding._id === share.funding._id
        })

        if (added) {
          this.rounds[index].totalShares += share.totalShares
          this.rounds[index].totalValue += share.totalValue
        } else {
          this.rounds.push({
            funding: share.funding,
            totalShares: share.totalShares,
            totalValue: share.totalValue
          })
        }
      })
    },

    getSharesAvailable () {
      const round = this.rounds.find(r => r.funding._id === this.payload.funding)

      this.max = round.totalValue
    },

    submit () {
      this.dissolve(this.payload)
        .then(() => {
          this.payload.amount = ''
          this.payload.funding = ''
          this.payload.user = ''

          EventBus.$emit('reload-PaginatedList-shares')

          this.$flash.success('Shares successfully removed')
          this.$modal.close('#investorRemoveSharesModal')
        })
        .catch(err => this.$flash.failure(err))
    },

    ...mapActions({
      dissolve: 'core/shares/dissolve',
      getInvestors: 'core/user-investments/all',
      getTrail: 'core/shares/trail'
    })
  }
}
</script>
